import { getOrderByIdQuery } from '@util/firestore/orders/orders.service';
import { onSnapshot } from 'firebase/firestore';
import { OrderDocument } from 'models/order';
import { useEffect, useMemo, useState } from 'react';

const useRealTimeOrder = (id?: string) => {
  const [realTimeOrder, setRealtimeOrder] = useState<OrderDocument | null>(
    null
  );
  const orderQuery = useMemo(() => (id ? getOrderByIdQuery(id) : null), [id]);
  useEffect(() => {
    if (!orderQuery) return;
    const unsubscribe = onSnapshot(orderQuery, (snapshot) => {
      const realTimeData = snapshot.data() as OrderDocument;
      setRealtimeOrder(realTimeData);
    });
    return () => {
      unsubscribe();
    };
  }, [orderQuery]);

  return realTimeOrder;
};

export default useRealTimeOrder;
